import React, { useEffect } from 'react'
import PropTypes from 'prop-types'

import { Button } from '../Button/BTTButton'
import './TitleBar.scss'
import {
  clearFromLocalStorage,
  loadFromLocalStorage,
} from '../../../helpers/localStorage.js'

const TitleBar = ({
  exerciseName,
  currentStep,
  totalSteps,
  completedSteps,
  complete,
  onPreviousStep,
  onNextStep,
}) => {
  const stepText = complete
    ? 'Completed'
    : `Step ${currentStep} / ${totalSteps}`
  const hasCompletedStep = completedSteps > currentStep
  const mayMoveForward = currentStep <= totalSteps && hasCompletedStep
  const mayMoveBack = currentStep > 1

  useEffect(() => {
    if (currentStep === totalSteps + 1) {
      clearFromLocalStorage(
        'selections',
        Object.keys(loadFromLocalStorage('selections') || {})
      )
    }
  }, [currentStep])

  return (
    <div className="title-bar">
      <h1 className="title-bar__name">{exerciseName}</h1>
      <div className="title-bar__step-navigation">
        <Button
          type="secondary"
          icon="chevron_left"
          iconOnly={true}
          onClick={onPreviousStep}
          disabled={!mayMoveBack}
          variant="3d"
        />
        <span className="title-bar__step-number">{stepText}</span>
        <Button
          type="secondary"
          icon="chevron_right"
          iconOnly={true}
          onClick={onNextStep}
          disabled={!mayMoveForward}
          variant="3d"
        />
      </div>
    </div>
  )
}

TitleBar.propTypes = {
  exerciseName: PropTypes.string,
  currentStep: PropTypes.number.isRequired,
  totalSteps: PropTypes.number.isRequired,
  completedSteps: PropTypes.number.isRequired,
  onPreviousStep: PropTypes.func,
  onNextStep: PropTypes.func,
  complete: PropTypes.bool,
}

export default TitleBar
